module.exports = __webpack_public_path__ + "img/image132.298fb172.png";